// La mesa de destino de un arrastre, marcada bajo el puntero (si hay alguien, se cambian el sitio). Neutra: en «Ordenar»
// el único oro es el «Listo» de la barra (visual.md #12).
import type { CSSProperties } from 'react';
import { t } from '../../../i18n';
import { cn } from '../../../lib/utils';

/**
 * Sin `estilo` va DENTRO de la caja de la mesa (ya colocada) y la ocupa entera; con `estilo`, suelta, se coloca ella
 * (mesas sin nada que pulsar). Colocarla dos veces la desplazaba a otra mesa (captura del 09-10).
 */
export function MarcaDestino({ ocupada, estilo }: { ocupada: boolean; estilo?: CSSProperties }) {
  return (
    <span
      className={cn('pointer-events-none absolute z-10 flex items-end justify-center rounded-o-m border-2 border-dashed border-oficina-texto2 bg-oficina-pulsado/40 pb-1', !estilo && 'inset-0')}
      style={estilo}
      aria-hidden
    >
      <span className="rounded-o-s bg-oficina-texto px-1.5 text-o-mini font-semibold text-oficina-fondo">{t(ocupada ? 'oficinaV2.mesas.cambiarSitio' : 'oficinaV2.mesas.moverAqui')}</span>
    </span>
  );
}
